import route from "@/components/router/Router"
const routes = [
    {
        path : "land-carrier-add",
        name : "land-carrier-add",
        meta : {
            title : "土地载体-载体录入"
        },
        component: () => import('@/pages/land/inputCarrier/Index')
    },
    {
        path : "land-carrier-edit/:id",
        name : "land-carrier-edit",
        meta : {
            title : "土地载体-载体录入"
        },
        component: () => import('@/pages/land/inputCarrier/Index')
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/land/inputcarrier/index.js